
/* tslint:disable */
/* eslint-disable */
/**
 * Client dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ProjectAnalyticsRequest,
  ProjectAnalyticsResponse,
} from '../models';
import {
    ProjectAnalyticsRequestFromJSON,
    ProjectAnalyticsRequestToJSON,
    ProjectAnalyticsResponseFromJSON,
    ProjectAnalyticsResponseToJSON,
} from '../models';

export interface GetAnalyticsRequest {
    projectAnalyticsRequest: ProjectAnalyticsRequest;
}

/**
 * 
 */
export class ProjectAnalyticsApi extends runtime.BaseAPI {

    /**
     * Check if the user has access to analytics
          */
    async checkAnalyticsAccessRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<boolean>({
            path: `/dashboard-client/api/analytics/projects`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Check if the user has access to analytics
          */
    async checkAnalyticsAccess(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.checkAnalyticsAccessRaw(initOverrides);
        return response._data;
    }

    /**
     * Get Project related analytics for the given organization
          */
    async getAnalyticsRaw(requestParameters: GetAnalyticsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectAnalyticsResponse>> {
        if (requestParameters['projectAnalyticsRequest'] == null) {
            throw new runtime.RequiredError(
                'projectAnalyticsRequest',
                'Required parameter "projectAnalyticsRequest" was null or undefined when calling getAnalytics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ProjectAnalyticsResponse>({
            path: `/dashboard-client/api/analytics/projects`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectAnalyticsRequestToJSON(requestParameters['projectAnalyticsRequest']),
        }, initOverrides);

        if (response._data) { response._data=ProjectAnalyticsResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Get Project related analytics for the given organization
          */
    async getAnalytics(requestParameters: GetAnalyticsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectAnalyticsResponse> {
        const response = await this.getAnalyticsRaw(requestParameters, initOverrides);
        return response._data;
    }

}
